import {createContext, useContext, useEffect} from 'react'

export const ModalContext = createContext({})
export const ModalProvider = ModalContext.Provider

export const useModalContext = () => useContext(ModalContext)

export const useSetModalPropsRaw = (data, watch = []) => {
	const {setModalPropsRaw} = useModalContext()
	useEffect(() => {
		setModalPropsRaw(data)
	}, watch)
}
